export default __webpack_public_path__ + "static/media/redis_monitor.9c092024.md";